import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ToolboxTalksEditComponent } from './toolbox-talks-edit/toolbox-talks-edit.component';
import { ToolboxTalksComponent } from './toolbox-talks/toolbox-talks.component';
import { AuthGuard } from '../guards/auth.guard';
import { RBACGuard } from '../guards/rbac.guard';
import { RBACService } from '../shared/rbac.service';
import { PlanGuard } from '../guards/plan.guard';
import { AppService } from '../app.service';
import { ToolboxTalksTabsComponent } from "./toolbox-talks-tabs/toolbox-talks-tabs.component";
import { ToolboxTalksTemplatesComponent } from './toolbox-talks-templates/toolbox-talks-templates.component';
import { ToolboxTalksTemplatesTabsComponent } from "./toolbox-talks-templates-tabs/toolbox-talks-templates-tabs.component";
import { ToolboxTalksTemplatesEditComponent } from "./toolbox-talks-templates-edit/toolbox-talks-templates-edit.component";
import { ToolboxTalksTemplatesImporterComponent } from './toolbox-talks-templates-importer/toolbox-talks-templates-importer.component';

const routes: Routes = [
  {
    path: 'toolbox-talks',
    canActivate: [
      AuthGuard,
      PlanGuard
    ],
    data: { planFeature: AppService.FEATURES.TOOLBOX_TALKS },
    children: [
      { path: '', component: ToolboxTalksComponent },
      { path: ':toolbox_talk_id/edit', component: ToolboxTalksEditComponent },
      { path: ':toolbox_talk_id/view', component: ToolboxTalksTabsComponent }
    ]
   },
   {
     path: 'toolbox-talks-templates/importer',
     component: ToolboxTalksTemplatesImporterComponent,
     canActivate: [
       AuthGuard,
       PlanGuard,
       RBACGuard
     ],
     data: {
       planFeature: AppService.FEATURES.TOOLBOX_TALKS,
       permissions: [
         RBACService.getPermission(RBACService.RBAC_F.F_TEMPLATES_TOOLBOX_TALKS, RBACService.RBAC_A.A_CREATE)
       ],
       exact: true
     }
   },
   {
     path: 'toolbox-talks-templates',
     component: ToolboxTalksTemplatesComponent,
     canActivate: [
       AuthGuard,
       PlanGuard
     ],
     data: { planFeature: AppService.FEATURES.TOOLBOX_TALKS }
   },
  {
    path: 'toolbox-talks-templates/:toolbox_talk_id',
    children: [
      { path: 'edit', component: ToolboxTalksTemplatesEditComponent },
      { path: 'view', component: ToolboxTalksTemplatesTabsComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ToolboxTalksRoutingModule {}
